import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetScsDictItems } from '@/api/api';
import debounce from 'lodash/debounce';
import { getAction } from "../../api/manage";
export default {
  name: 'ScsSearchSelectTag',
  props: {
    disabled: Boolean,
    value: String,
    dict: String,
    dictOptions: Array,
    async: Boolean,
    placeholder: {
      type: String,
      default: "请选择",
      required: false
    }
  },
  data: function data() {
    this.loadData = debounce(this.loadData, 800); //消抖

    this.lastLoad = 0;
    return {
      loading: false,
      selectedValue: [],
      selectedAsyncValue: [],
      options: []
    };
  },
  created: function created() {
    this.initDictData();
  },
  watch: {
    "value": {
      immediate: true,
      handler: function handler(val) {
        if (!val) {
          this.selectedValue = [];
          this.selectedAsyncValue = [];
        } else {
          this.initSelectValue();
        }
      }
    },
    "dict": {
      handler: function handler() {
        this.initDictData();
      }
    }
  },
  methods: {
    initSelectValue: function initSelectValue() {
      var _this = this;

      if (this.async) {
        if (!this.selectedAsyncValue || !this.selectedAsyncValue.key || this.selectedAsyncValue.key != this.value) {
          console.log("这才请求后台");
          getAction("/scs/dict/loadDictItem/".concat(this.dict), {
            key: this.value
          }).then(function (res) {
            if (res.success) {
              var obj = {
                key: _this.value,
                label: res.result
              };
              _this.selectedAsyncValue = _objectSpread({}, obj);
            }
          });
        }
      } else {
        this.selectedValue = this.value;
      }
    },
    loadData: function loadData(value) {
      var _this2 = this;

      console.log("数据加载", value);
      this.lastLoad += 1;
      var currentLoad = this.lastLoad;
      this.options = [];
      this.loading = true; // 字典code格式：table,text,code

      getAction("/scs/dict/loadDict/".concat(this.dict), {
        keyword: value
      }).then(function (res) {
        _this2.loading = false;

        if (res.success) {
          if (currentLoad != _this2.lastLoad) {
            return;
          }

          _this2.options = res.result;
          console.log("我是第一个", res);
        } else {
          _this2.$notification.warning({
            message: res.message
          });
        }
      });
    },
    initDictData: function initDictData() {
      var _this3 = this;

      if (!this.async) {
        //如果字典项集合有数据
        if (this.dictOptions && this.dictOptions.length > 0) {
          this.options = _toConsumableArray(this.dictOptions);
        } else {
          //根据字典Code, 初始化字典数组
          ajaxGetScsDictItems(this.dict, null).then(function (res) {
            if (res.success) {
              _this3.options = res.result;
            }
          });
        }
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleChange: function handleChange(selectedValue) {
      console.log("selectedValue", selectedValue);
      this.selectedValue = selectedValue;
      this.callback();
    },
    handleAsyncChange: function handleAsyncChange(selectedObj) {
      this.selectedAsyncValue = selectedObj;
      this.selectedValue = selectedObj.key;
      this.callback();
    },
    callback: function callback() {
      this.$emit('change', this.selectedValue);
    },
    setCurrentDictOptions: function setCurrentDictOptions(dictOptions) {
      this.options = dictOptions;
    },
    getCurrentDictOptions: function getCurrentDictOptions() {
      return this.options;
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
};